import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { Footer } from './Footer'
import { Navbar } from './Navbar'
import { BackToTop } from './BackToTop'

export const MainLayout = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])

  return (
    <div className="flex min-h-screen flex-col bg-surface-light text-base-900">
      <a
        href="#main-content"
        className="fixed left-4 top-3 z-[100] -translate-y-20 rounded-lg bg-green-700 px-4 py-2 text-sm font-medium text-white focus:translate-y-0"
      >
        Skip to content
      </a>
      <Navbar />
      <main key={pathname} id="main-content" className="flex-1 animate-fade-in">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </div>
  )
}
